import React, { Component } from "react";
import {
  Button,
  FormGroup,
  InputGroup,
  Callout
} from "@blueprintjs/core";
import { withFirebase } from "../components/Firebase";
import { withRouter, RouteComponentProps } from "react-router-dom";
import FormWrapper from "../components/FormWrapper";

const INITIAL_STATE = {
  username: "",
  email: "",
  passwordOne: "",
  passwordTwo: "",
  error: null,
  loading: false
};

interface Props extends RouteComponentProps {
  firebase: any;
}

interface State {
  username: string;
  email: string;
  passwordOne: string;
  passwordTwo: string;
  error: {
    message: string;
  } | null;
  loading: boolean;
  [s: string]: any;
}

class SignUp extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    this.setState({ loading: true });
    const { username, email, passwordOne } = this.state;

    this.props.firebase
      .doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push("/live");
      })
      .catch(error => {
        this.setState({ error, loading: false });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { username, email, passwordOne, passwordTwo, error } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === "" ||
      email === "" ||
      username === "";

    return (
      <FormWrapper>
        <form onSubmit={this.onSubmit}>
          {error && (
            <Callout intent="warning" style={{ marginBottom: "1em" }}>
              {error.message}
            </Callout>
          )}
          <FormGroup style={{ width: "300px" }} label="Username">
            <InputGroup
              placeholder="Username"
              name="username"
              value={username}
              onChange={this.onChange}
            />
          </FormGroup>
          <FormGroup style={{ width: "300px" }} label="Email Address">
            <InputGroup
              name="email"
              value={email}
              onChange={this.onChange}
              type="text"
              placeholder="Email Address"
            />
          </FormGroup>
          <FormGroup style={{ width: "300px" }} label="Password">
            <InputGroup
              name="passwordOne"
              value={passwordOne}
              onChange={this.onChange}
              type="password"
              placeholder="Password"
            />
          </FormGroup>
          <FormGroup style={{ width: "300px" }} label="Repeat Password">
            <InputGroup
              name="passwordTwo"
              value={passwordTwo}
              onChange={this.onChange}
              type="password"
              placeholder="Confirm Password"
            />
          </FormGroup>
          <Button
            type="submit"
            intent="primary"
            disabled={isInvalid}
            icon="new-person"
            loading={this.state.loading}
          >
            Sign Up
          </Button>
        </form>
      </FormWrapper>
    );
  }
}

export default withFirebase(withRouter(SignUp));
